import { createApi } from '@stilingue/st-auth-utils';
import StService from '@stilingue/st-service';

export class StAuthService extends StService {
  constructor(gateway, version) {
    const api = createApi(`auth/${version}/session/`, gateway, {
      authNotFound: () => true,
      error401Handler: (error) => {
        // eslint-disable-next-line no-undef
        return Promise.reject(error);
      }
    });
    super(api, { });
  }

  login(username, password) {
    const params = { username, password };
    return this.api.post({ ...params, url: 'login' });
  }

  token(username, password) {
    const params = { username, password };
    return this.api.post({ ...params, url: 'v2/token' });
  }

  tokenFromSession(sessionId) {
    const params = { sessionId };
    return this.api.post({ ...params, url: 'v2/token-from-session' });
  }

  recoverPassword(username) {
    const params = { username };
    return this.api.post({ ...params, url: 'v2/password/recover' });
  }

  exchange(token) {
    const params = { token };
    return this.api.post({ ...params, url: 'v2/token/exchange' });
  }

  logout(SSID) {
    const params = { 'Stilingue-Session-Id': SSID };
    return this.api.post({ ...params, url: 'logout' });
  }
}
